module.exports = __webpack_public_path__ + "img/ic_fluent_arrow_right_20_regular.b13ba87a.svg";